import { encryptWithRSAPublicKey } from '../../../../utils/encryptWithRSAPublicKey';
import { setCookie } from '../../../../utils/setCookie';
import { useAccessTokenFromHash } from './useAccessTokenFromHash';

export const useCheckDirectAccessToken = () => {
    const { token, expiresIn } = useAccessTokenFromHash();

    if (token) {
        const encryptedToken = encryptWithRSAPublicKey(token);
        if (!encryptedToken) {
            return;
        }

        setCookie('direct_access_token', encryptedToken, expiresIn);

        // удаляем access токен из хэша после записи в куку
        window.history.replaceState(null, '', window.location.pathname + window.location.search);
    }
};
